import CalloutRepository from "../CalloutRepository"

export default class WhyPodiemCallout extends CalloutRepository {
    static schemaId = "why_us_callout"

    constructor() {
        super(WhyPodiemCallout.schemaId)
    }
}
